// src/com/user_info/UserAndAlloc.js
import React, { useEffect, useState } from 'react';
import TopViewControl from '../../common/TopViewControl';
import ServiceTabs from '../menu_info/ServiceTabs';
import { menuRequestRepo } from '../../value/AppModel';
import UserInfo from './UserInfo';
import UserAlloc from '../user_alloc/UserAlloc';
import { AppMenuUrl } from '../../value/AppConst';
import AuthTable from '../auth_table/AuthTable';

export default function UserAndAlloc({
    menu, parentMenu
}) {
    const [mountedViews, setMountedViews] = useState(() => ({
        [menu.menuUrl]: true,
    }));

    useEffect(() => {
        setMountedViews((prev) => {
            if(prev[menu.menuUrl]) return prev;
            return {...prev, [menu.menuUrl]: true};
        });
    }, [menu.menuUrl]);

    const onChangeTab = (v) => {
        const sib = parentMenu.children.find((child) => child.menuId === v);
        if(sib) {
            setMountedViews((prev) => {
                if(prev[sib.menuUrl]) return prev;
                return {...prev, [sib.menuUrl]: true};
            });
        }
        menuRequestRepo({menu:sib, parentMenu:parentMenu});
    };

    const viewServiceTags = <ServiceTabs menu={menu} parentMenu={parentMenu} onChangeTab={onChangeTab} />;

    // 사용자 정보, 승인요청 정보
    return(
        <TopViewControl>
            {mountedViews[AppMenuUrl.UserInfo] &&
                <UserInfo
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.UserInfo}
                />
            }
            {mountedViews[AppMenuUrl.AllocInfo] &&
                <UserAlloc
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.AllocInfo}
                />
            }
            {mountedViews[AppMenuUrl.UserProc] &&
                <AuthTable
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.UserProc}
                />
            }
        </TopViewControl>
    );
}